// extracted by mini-css-extract-plugin
export default {"w-full":"NewDeck_w-full__-njWo","row":"NewDeck_row__PGz6F","col":"NewDeck_col__JAi6M","card":"NewDeck_card__pNEYC","button":"NewDeck_button__vpU7Z"};